var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-20 text-center cursor-pointer",staticStyle:{"max-height":"300px","overflow":"hidden"},on:{"click":_vm.handleClick}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":_vm.bannerAd.coverurl,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }